import type { Quantity } from '@medplum/fhirtypes';
import { QUANTITY_TRANSLATION_EXTENSION } from './constants';

/** UCUM codes the ingest pipeline writes as imperial quantity-translations and readers prefer for display. */
export const IMPERIAL_UCUM_CODES = new Set(['[lb_av]', '[in_us]', '[degF]']);

/**
 * The imperial quantity-translation when present, else the quantity as stored. The standard
 * extension can hold a translation in any unit, so this specifically picks one whose UCUM code
 * is an imperial display target rather than blindly taking the first.
 */
export const preferImperialQuantity = (qty: Quantity | undefined): Quantity | undefined => {
  const imperial = qty?.extension
    ?.filter((e) => e.url === QUANTITY_TRANSLATION_EXTENSION)
    .map((e) => e.valueQuantity)
    .find((t) => t?.code !== undefined && IMPERIAL_UCUM_CODES.has(t.code));
  return imperial ?? qty;
};
